import React, { useMemo } from 'react';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';
import { useInternationalization } from '../../@data/store/InternationalizationProvider';
import { Globe } from 'react-feather';
import {
  SupportedLanguage,
  SupportedPortalLanguages,
} from '../../@data/utility/supportedLanguages';
import { useMessages } from '@hooks/useMessages';

const IntlDropdown: React.FC = () => {
  const { language, switchLanguage } = useInternationalization();
  const { messages } = useMessages();

  const selectedOption = useMemo(
    () => (language ? SupportedPortalLanguages[language] : undefined),
    [language]
  );

  // Function to switch Language
  const handleLangUpdate = (
    e: React.MouseEvent<HTMLElement>,
    lang: SupportedLanguage
  ) => {
    e.preventDefault();
    if (lang && switchLanguage) {
      switchLanguage(lang.id);
    }
  };

  return (
    <UncontrolledDropdown
      tag="li"
      className="dropdown-language nav-item mr-sm-1"
    >
      <DropdownToggle
        color="transparent"
        onClick={(e) => e.preventDefault()}
        className="px-50 py-0"
      >
        <div className="d-flex align-items-center">
          <Globe size={21} />
          <h5 className="ml-50 mb-0 selected-language">
            {selectedOption ? messages(selectedOption?.title) : ''}
          </h5>
        </div>
      </DropdownToggle>
      <DropdownMenu className="mt-0" right>
        {Object.values(SupportedPortalLanguages).map((option) => {
          return (
            <DropdownItem
              key={option.id}
              href="/"
              tag="a"
              onClick={(e) => handleLangUpdate(e, option)}
            >
              <span>{messages(option.title)}</span>
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default IntlDropdown;
